import * as React from 'react';
import Box from '@mui/material/Box';
import { useState, useEffect } from 'react';
import Searchbar from 'src/layouts/dashboard/Searchbar';
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  Modal,
  CircularProgress,
  Pagination,
  Tooltip,
  CardContent
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useTranslation } from 'react-i18next';
import { Encryption } from 'src/functions/function';
import { api } from '../Api';
import Page from '../components/Page';
import Iconify from '../components/Iconify';
import Scrollbar from '../components/Scrollbar';
import SearchNotFound from '../components/SearchNotFound';
import { UserListHead } from '../sections/@dashboard/user';
import TransactionModal from 'src/sections/@dashboard/wallets/transactionmodal';
import { Link as RouterLink } from 'react-router-dom';

export default function Wallet() {
  const { t } = useTranslation();

  const TABLE_HEAD = [
    { id: 'name', label: t('Users.table.0'), alignRight: false },
    { id: 'email', label: t('Users.table.1'), alignRight: false },
    { id: 'funds_available', label: 'Funds (LKR)', alignRight: false },
    { id: 'requested', label: 'Requested (LKR)', alignRight: false },
    { id: 'onhold', label: 'On Hold (LKR)', alignRight: false },
    { id: 'declined', label: 'Declined (LKR)', alignRight: false },
    { id: 'approved', label: 'Approved (LKR)', alignRight: false },
    { id: 'refunded', label: 'Refunded (LKR)', alignRight: false },
    { id: 'action', label: 'Actions', alignRight: false }
  ];

  const [permission, setpermission] = useState([]);
  const requirement = ['visible', 'transaction detail'];

  function checkRender() {
    let check = 'wallet';
    const localPerm = JSON.parse(localStorage.getItem('permissions'))?.filter(
      (item) => item.permission_name.toLowerCase() == check
    );
    localPerm[0]?.permission_types?.filter((items) =>
      requirement.includes(items.permission_type_name.toLowerCase())
        ? setpermission((permissions) => [...permissions, items.permission_type_name.toLowerCase()])
        : false
    );
  }

  const [list, setlist] = useState([]);
  const [data, setData] = useState(null);
  const [search, setsearch] = useState('');
  const [page, setPage] = React.useState(1);
  const [loading, setloading] = useState(true);
  const [pagesCount, setpagesCount] = useState(1);
  const [searchLoading, setsearchLoading] = useState(false);
  const [OpenTransactionModal, setOpenTransactionModal] = React.useState(false);
  const isUserNotFound = list.length === 0;
  const [openDetail, setOpenDetail] = React.useState(false);
  const handleOpenDetails = () => setOpenDetail(true);
  const [user, setuser] = useState(null);

  const handleCloseTransactionModal = () => {
    setOpenTransactionModal(false);
  };

  function openBankDetailsModal(user) {
    setuser(user);
    handleOpenDetails();
  }

  useEffect(() => {
    checkRender();
  }, []);

  useEffect(() => {
    if (search.length == 0) {
      list.length = 0;
      getWallets();
    }
  }, [search]);

  useEffect(() => {
    getWallets();
  }, []);

  function getWallets(page) {
    setloading(true);

    const myHeaders = new Headers();
    const token = localStorage.getItem('token');

    myHeaders.append('Authorization', `Bearer ${token}`);

    // Construct the query parameters
    const params = new URLSearchParams();

    if (search.length > 0) {
      params.append('search', Encryption(search, process.env.REACT_APP_SECRET_KEY));
    }
    if (page) {
      params.append('page', Encryption(page, process.env.REACT_APP_SECRET_KEY));
    }

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(`${api.get_wallet}?${params.toString()}`, requestOptions)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          return response.json();
        } else {
          throw new Error('Failed to fetch data');
        }
      })
      .then((result) => {
        console.log('result', result);
        const decryptedData = result.data;
        setlist(decryptedData);
        setpagesCount(result.count ? Math.ceil(result.count / 20) : 1);
      })
      .catch((error) => {
        console.log('error', error);
        setlist([]);
        setpagesCount(0);
      })
      .finally(() => {
        setloading(false);
        setsearchLoading(false);
      });
  }

  const handleCloseDetails = () => {
    setOpenDetail(false);
    setuser(null);
  };

  const formatNumberWithCommas = (value) => {
    if (value === null || value === undefined || isNaN(Number(value))) return '0';
    const number = Number(value);
    return number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const handlePageChange = (event, value) => {
    list.length = 0;
    setPage(value);
    getWallets(value);
  };

  const style = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    width: '100%',
    height: '80%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 1,
    border: '2px solid',
    borderColor: 'primary.main'
  };

  const boxStyle = {
    display: 'flex',
    maxWidth: '80%',
    maxHeight: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    overflow: 'auto',
    p: 4,
    border: '2px solid',
    borderColor: 'primary.main'
  };

  function openTransactionModal(row) {
    setData(row);
    setOpenTransactionModal(true);
  }

  const maskCardNumber = (cardNo) => {
    if (!cardNo) return 'N/A';
    return `${cardNo.slice(0, 4)}-****-****-${cardNo.slice(-4)}`;
  };
  return (
    <Page title={`Subcribtions | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        {/* TRANSACTIONS  DETAILS */}
        <Modal
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%',
            overflow: 'scroll'
          }}
          open={OpenTransactionModal}
          onClose={handleCloseTransactionModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={{ ...boxStyle, maxWidth: '80%' }} className="admin_modal_pa">
            <TransactionModal user_id={data?.id} handleClose={handleCloseTransactionModal} />
          </Box>
        </Modal>

        {/* OPEN DETAILS */}
        <Modal
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%'
          }}
          open={openDetail}
          onClose={handleCloseDetails}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={{ ...boxStyle, maxWidth: '40%' }} className="admin_modal_pa">
            <Box p={1} py={3} flexDirection={'column'} display={'flex'} flex={1}>
              <Typography variant="h4" style={{ fontWeight: 'bold', textAlign: 'center' }}>
                Bank Detail
              </Typography>
              <CardContent>
                <Box>
                  <Typography variant="body1" color="textSecondary">
                    Bank Name: {user?.user?.default_bank?.bank_name || 'N/A'}
                  </Typography>
                  <Typography variant="body1" color="textSecondary">
                    Branch Name: {user?.user?.default_bank?.branch_name || 'N/A'}
                  </Typography>
                  <Typography variant="body1" color="textSecondary">
                    Account Number: {maskCardNumber(user?.user?.default_bank?.account_no) || 'N/A'}
                  </Typography>
                </Box>

                <Box style={{ marginTop: 20 }} display={'flex'} justifyContent={'flex-end'}>
                  <Button
                    color="primary"
                    variant="outlined"
                    onClick={handleCloseDetails}
                    size="large"
                  >
                    Close
                  </Button>
                </Box>
              </CardContent>
            </Box>
          </Box>
        </Modal>

        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h4" gutterBottom>
            Subcribtion
          </Typography>
        </Stack>

        <Card>
          <Box
            p={2}
            style={{
              flexDirection: 'row',
              display: 'flex',
              flex: 1
            }}
            className="top_column"
          >
            <Searchbar
              width={'90%'}
              value={search}
              setFunction={(val) => {
                setsearch(val);
              }}
              className="width_full_property"
              placeholder={t('Agents.search')}
              onEnter={() => {
                setsearchLoading(true);
                setPage(1);
                getWallets(1);
              }}
            />

            <LoadingButton
              style={{ width: '15%', marginLeft: '2.5%' }}
              variant="contained"
              loading={searchLoading}
              onClick={() => {
                setsearchLoading(true);
                setPage(1);
                getWallets(1);
              }}
              className="width_full_status"
            >
              {' '}
              <Iconify icon="material-symbols:search" sx={{ width: 25, height: 25 }} />
            </LoadingButton>
          </Box>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  textStyle={{ fontSize: 12 }}
                  headLabel={TABLE_HEAD}
                  rowCount={list.length}
                />
                <TableBody>
                  {list?.map((row) => {
                    console.log('result map', row);
                    const {
                      id,
                      user,
                      available_withdraw,
                      requested,
                      onhold,
                      declined,
                      approved,
                      refunded,
                      avatar,
                      name,
                      email,
                      wallets
                    } = row;

                    return (
                      <TableRow hover onClick={() => {}} key={id} tabIndex={-1} role="checkbox">
                        {/* NAME & AVATAR */}
                        <TableCell scope="row" padding="normal" style={{ width: 145 }}>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                            style={{ width: 145 }}
                          >
                            <Avatar alt={user?.name} src={avatar} />
                            <Box style={{ display: 'flex', flexDirection: 'column', width: 145 }}>
                              <Typography fontSize={11} variant="subtitle2" flexWrap={'wrap'}>
                                {name === 'undefined' ? 'N/A' : name}
                              </Typography>
                            </Box>
                          </Stack>
                        </TableCell>
                        {/* EMAIL */}
                        <TableCell align="left" style={{ minWidth: 160 }}>
                          <Typography fontSize={11} noWrap>
                            {email || 'N/A'}
                          </Typography>
                        </TableCell>
                        {/* AVAILABLE WITHDRAW */}
                        <TableCell align="left">
                          <Typography fontSize={11} noWrap>
                            {wallets?.available_withdraw
                              ? formatNumberWithCommas(wallets?.available_withdraw)
                              : 'N/A'}
                          </Typography>
                        </TableCell>
                        {/* REQUESTED */}
                        <TableCell align="left">
                          <Typography fontSize={11} noWrap>
                            {wallets?.requested
                              ? formatNumberWithCommas(wallets?.requested)
                              : 'N/A'}
                          </Typography>
                        </TableCell>
                        {/* ON-HOLD */}
                        <TableCell align="left">
                          <Typography fontSize={11} noWrap>
                            {wallets?.onhold ? formatNumberWithCommas(wallets?.onhold) : 'N/A'}
                          </Typography>
                        </TableCell>
                        {/* DECLINED */}
                        <TableCell align="left">
                          <Typography fontSize={11} noWrap>
                            {wallets?.declined ? formatNumberWithCommas(wallets?.declined) : 'N/A'}
                          </Typography>
                        </TableCell>
                        {/* APPROVED */}
                        <TableCell align="left">
                          <Typography fontSize={11} noWrap>
                            {wallets?.approved ? formatNumberWithCommas(wallets?.approved) : 'N/A'}
                          </Typography>
                        </TableCell>
                        {/* REFUNDED */}
                        <TableCell align="left">
                          <Typography fontSize={11} noWrap>
                            {wallets?.refunded ? formatNumberWithCommas(wallets?.refunded) : 'N/A'}
                            {/* {wallets?.refunded} */}
                          </Typography>
                        </TableCell>

                        <TableCell align="left" style={{ minWidth: 155 }}>
                          {permission.includes('transaction detail') && (
                            <Tooltip title="Transactions">
                              <LoadingButton
                                size="small"
                                onClick={() => {
                                  openTransactionModal(row);
                                }}
                                style={{
                                  justifyContent: 'center',
                                  width: 30, // Less than 30
                                  height: 30, // Ensuring it's a square button
                                  minWidth: 30, // Ensuring minimum width is set to 30
                                  padding: 0, // Removing padding to fit the icon properly
                                  lineHeight: 1, // Ensuring the icon is centered
                                  alignSelf: 'center',
                                  marginLeft: 1
                                }}
                                to="#"
                              >
                                <Iconify
                                  style={{ cursor: 'pointer', fontSize: 27 }}
                                  icon="bitcoin-icons:transactions-filled"
                                />
                              </LoadingButton>
                            </Tooltip>
                          )}
                          <Tooltip title="Bank Detail">
                            <LoadingButton
                              size="small"
                              onClick={() => openBankDetailsModal(row)}
                              style={{
                                justifyContent: 'center',
                                width: 30, // Less than 30
                                height: 30, // Ensuring it's a square button
                                minWidth: 30, // Ensuring minimum width is set to 30
                                padding: 0, // Removing padding to fit the icon properly
                                lineHeight: 1, // Ensuring the icon is centered
                                alignSelf: 'center',
                                marginLeft: 1
                              }}
                              component={RouterLink}
                              to="#"
                            >
                              <Iconify
                                style={{ cursor: 'pointer', fontSize: 18 }}
                                icon="mdi:bank"
                              />
                            </LoadingButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>

                {isUserNotFound && !loading && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={11} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
              {loading && !searchLoading && (
                <Box
                  py={5}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    flex: 1
                  }}
                >
                  <CircularProgress />
                </Box>
              )}
            </TableContainer>
          </Scrollbar>
        </Card>
        {!loading && !searchLoading && pagesCount > 1 && (
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              marginTop: 10,
              alignItems: 'center'
            }}
          >
            <Pagination
              count={pagesCount}
              color="primary"
              variant="outlined"
              shape="rounded"
              onChange={handlePageChange}
              page={page}
            />
          </Box>
        )}
      </Container>
    </Page>
  );
}
